/**
 *
 * Asynchronously loads the component for FeeReceipt
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const FeeReceipt = lazyLoad(
    () => import('./index'),
    module => module.default,
);
